module.exports = __webpack_public_path__ + "static/img/img_11.b2372d7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/production/images/img_11.webp
// module id = LNOl
// module chunks = 8